<template>
  <CModal
    :title="'Gestión de grupos de reglas'"
    size="sm"
    :show.sync="openGroupManager"
    :color="'dark'"
  >
    <CForm>
      <CInput
        label="Nombre del nuevo grupo (opcional)"
        :value.sync="groupName"
        placeholder="Ej: Alternativa mínima"
      />
      <CButton color="dark" @click="createGroup">Crear grupo</CButton>

      <div class="mt-4">
        <h6 class="mb-3">Grupos existentes</h6>
        <div v-if="Array.isArray(localGroups) && localGroups.length">
          <ul class="list-unstyled small pl-0 pr-0 mb-0">
            <li
              v-for="(g, i) in localGroups"
              :key="g.id"
              class="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2"
            >
              <span class="text-truncate" style="max-width: 70%">
                {{ g.description || 'Grupo sin nombre' }} – {{ (g.rules ? g.rules.length : 0) }} regla(s)
              </span>
              <CButton size="sm" color="danger" @click="removeGroup(i)">Eliminar</CButton>
            </li>
          </ul>
        </div>
        <div v-else class="text-muted small">Aún no hay grupos creados.</div>
      </div>
    </CForm>

    <template #footer>
      <CButton color="secondary" @click="closeModal">Cerrar</CButton>
    </template>
  </CModal>
</template>

<script>
export default {
  name: 'GroupRulesModal',
  props: {
    show: Boolean,
    groups: Array
  },
  data () {
    return {
      groupName: '',
      localGroups: [],
      openGroupManager: false
    }
  },
  methods: {
    createGroup () {
      const label = this.groupName.trim()

      if (!label) {
        this.$emit('toast', { type: 'danger', message: 'El nombre del grupo es requerido' })
        return
      }

      // Emitimos solo los datos, el padre se encarga de guardar en el back
      this.$emit('create-group', {
        description: label,
        operator: 'OR',
        rules: []
      })

      this.groupName = ''
    },
    removeGroup (index) {
      this.$emit('remove-group', index)
    },
    openModal(){
      this.openGroupManager = true;
    },
    closeModal(){
      this.openGroupManager = false;
    }
  },
  watch: {
    groups: {
      immediate: true,
      deep: true,
      handler (val) {
        this.localGroups = Array.isArray(val) ? [...val] : []
      }
    }
  }
}
</script>
